import axios from "axios";
import cache from "../config/cache";
import {headersTemplate} from "./options";
import errorEvent from "./error";

function setHeader (config) {
    headersTemplate.forEach(element => {
        if (cache.hasOwnProperty(element)) {
            config.headers[element] = cache[element];
        }
    });

    config.headers['x-track-code'] = uuidv4();
    if (config.headers.isBaseURL !== false) {
        config.baseURL = cache.get('baseURL');
    }
    else {
        delete(config.headers.isBaseURL)
    }
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : ( r & 0x3 | 0x8);
      return v.toString(16);
    })
}

export function proInterceptors () {
    axios.interceptors.request.use((config) => {
        if (config.headers.check !== false) {
            if (config.headers.isBaseURL !== false) {
                interceptEvent(config);
            }
        }
        setHeader(config);
        getURL(config);
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.response) {
            return errorEvent(error);
        }
    });
}

export function devInterceptors () {
    axios.interceptors.request.use((config) => {
        setHeader(config);
        getURL(config);
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        return errorEvent(error);
    });
}

// 拦截
function interceptEvent (config) {
    let resoucesIds = cache.get('resoucesIds');
    let resourceCode = config.headers['x-resource-code'];
    // let configURL = config['method'] + ',' + ((config.url.indexOf("?") == -1) ? config.url : config.url.slice(0, config.url.indexOf("?")));
    // if (resouces[configURL]) {
    //    config.headers['x-resource-code'] = resouces[configURL]['resourceId'];
    //    return;
    // }

    // for(let k in resouces) {
    //     if (k.charAt(k.length - 1) === '/' && (new RegExp(k)).test(configURL)) {
    //         let s = configURL.split(k);;
    //         let c = s[s.length-1];
    //         if (!(c.split('/').length - 1)) {
    //             config.headers['x-resource-code'] = resouces[k]['resourceId'];
    //             return;
    //         }
            
    //     }
    // }

    let urls = resoucesIds ? resoucesIds[resourceCode] : "";
    if (!urls) {
        console.error(resourceCode + " is not defined, please contact your Administrator");
        throw new Error();
    }
    return config
}

function getURL (config) {
    if (config.method === 'get') {
        config.url += (/\?/.test(config.url) ? "&" : "?") + "timestamp="+ new Date().getTime();
    }
}